module.exports = __webpack_public_path__ + "img/plan-amigo.c6efc510.png";